export default {"src":"/coding-school/_next/static/media/graduate.422e081e.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};